import styled from "styled-components";
import { ContainerStyled } from "../../../styles/shared-styles";
import { KeyButton } from "../../../services/visualLibraryService";

export const ParentalControlStyled = styled.section`
  padding: ${props => props.theme.baseLayoutPaddingBs}%;
`;

export const ContainerParentalStyled = styled(ContainerStyled)`
  padding-top: ${props => props.theme.spacing.xlarge};
  align-items: center;
`;

export const BlockStyled = styled.div`
  flex: 1;
  & + & {
    margin: 0 ${props => props.theme.baseLayoutPaddingBs}% 0;
  }
`;

export const ButtonsGroupStyled = styled.div`
  display: flex;
  margin-top: ${props => props.theme.spacing.small};
`;

export const KeyButtonStyled = styled(KeyButton)`
  width: 35vw;
  border: none !important;
`;
